import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default ({ routes, children }) => {
    const location = useLocation()
    useEffect(() => {
        // find matching route by pathname (exact match or alias)
        const route = routes.find(r => r.path === location.pathname) || routes[0]
        document.title = (route?.title ? route.title + ' - ' : '')
            + document.title.replace(/^[^-]+\s-\s/, '')
    }, [location])
    return children
}
